import { graphql } from "@opensea/graphql"
import { ItemMediaFragment } from "@/components/items/ItemMedia/ItemMedia.fragment"

export const ItemRewardMediaFragment = graphql(
  `
    fragment ItemRewardMedia on UserReward {
      id
      isGrandPrize
      item {
        ...ItemMedia
        chain {
          identifier
        }
      }
    }
  `,
  [ItemMediaFragment],
)
